import { render } from "./CoursesParClients.vue?vue&type=template&id=7a5a0f2e"
import script from "./CoursesParClients.vue?vue&type=script&lang=js"
export * from "./CoursesParClients.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__